import { IdentityUser } from "src/app/models/auth";

export interface ISignInState {
    loading: boolean;
    requireTFA: boolean;
    authFailText: string;
    hasFalseInception: boolean;
    advisorId: number;
    identityUsers: IdentityUser[];
}

export const initialSignInState: ISignInState = {
    loading: false,
    requireTFA: false,
    authFailText: '',
    hasFalseInception: false,
    advisorId: null,
    identityUsers: []
};
